import React from "react";

import "./Footer.css";

const Footer = () => {
  return (
    <footer className="footer">
      <div className="footer__content">
        <p className="footer__text brand">Sweetbeat</p>
        <p className="footer__text owner">&copy; Varchasvi Pandey</p>
      </div>
    </footer>
  );
};

export default Footer;
